module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "quotas-required-dialog",
    attrs: {
      "title": "永久项目额度不足",
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.close
    }
  }, [(_vm.organization) ? _c('div', [(_vm.overdate) ? _c('p', [_vm._v("企业套餐已过期，请联系管理员续费或升级")]) : _c('p', [_vm._v("企业套餐额度不足，请联系管理员续费或升级")])]) : _c('div', [_c('p', [_vm._v("您的永久项目额度不足，如果继续将会创建临时项目。临时项目会免费浏览8小时，之后会自动删除。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("您可以通过以下方式增加永久项目额度：")]), _vm._v(" "), _c('p', [_vm._v("\n      1. 购买单次项目额度；\n    ")]), _vm._v(" "), _c('p', [_vm._v("2. 购买会员套餐，升级账户；"), _c('a', {
    staticClass: "recommand",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_vm._v("查看优惠")])])]), _vm._v(" "), _c('div', {
    staticClass: "buttons",
    slot: "footer"
  }, [(_vm.organization) ? _c('div', [_c('a', {
    staticClass: "el-button el-button--primary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])]) : _c('div', [_c('a', {
    staticClass: "el-button el-button--text",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_vm._v("购买会员")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.purchase
    }
  }, [_vm._v("购买单次额度")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29d33608"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/setting/form/permanent/quotas_required.dialog.vue
// module id = 906
// module chunks = 3